module.exports = __webpack_public_path__ + "media/images/common/nav_3-172d69244072e7641483eb82adbfdeb0.png";